export const USER_PREFERENCE_PREFERENCE_KEYS = {
  CalendarRewriteOptIn: 'CALENDAR_REWRITE',
} as const;
